import React, { useEffect, useState } from 'react';
import * as Navigation from "../../../modules/Navigation";
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import IconChevronRight from '../../../assets/icons/icon-breadcrumb-chevron-right.svg';
import { httpGet } from '../../../modules/Backend';
import { LowerCaseFirstLetter } from '../../../helpers/EntityNameHelper';


export interface IBreadcrumbData{
    id: string,
    title: string,
    entityName:string
}

export default function Breadcrumbs() {
    const  {entityName, entityId} = useParams();
    const EntitiesThatNeedABreadcrumb: any[] = [];
    const [data, setData] = useState<IBreadcrumbData[]>();

    async function getData(){
        if(entityName && EntitiesThatNeedABreadcrumb.includes(entityName)){
            var result = await httpGet(`breadcrumb?entityId=${entityId}&entityName=${entityName}`);
            setData(result.data.breadcrumbItems);
        }
    }
    useEffect(() => {
        getData()
    }, [entityId])

    return <>
        {entityName && EntitiesThatNeedABreadcrumb.includes(entityName) &&
            <div className='display--flex flex__wrap--wrap'>
                {
                    data && data.map((breadcrumbData:IBreadcrumbData) => (
                        <Breadcrumb key={breadcrumbData.id} data={breadcrumbData}/>
                    ))
                }
            </div>
        }
    </>
};

export interface IBreadcrumb{
    data: IBreadcrumbData
}

export function Breadcrumb({data}:IBreadcrumb) {
    const navigate = useNavigate()

    function gotoEntity(){
        Navigation.view.navigate(navigate, LowerCaseFirstLetter(data.entityName), data.id);
    }

    return <button className='button display--flex alignItems--center flex__shrink--none' onClick={gotoEntity}><p className='small'>{data.title}</p><img src={IconChevronRight}/></button>
};